import { IsNotAuthenticated } from "@/components/authWrappers.component";
import type { RouteObject } from "react-router-dom";
import LoginPage from "./pages/Login.page";
import RegisterPage from "./pages/Register.page";
import PasswordResetPage from "./pages/PasswordReset.page";
import EmailVerificationPage from "./pages/EmailVerification.page";
import ActionHandlerPage from "./pages/ActionHandler.page";

// This is an example of how to lazy load the pages
// const Login = lazy(() => import('./pages/Login.page'));
// const Register = lazy(() => import('./pages/Register.page'));

import FinishSignupPage from "./pages/funnel/FinishSignup.page";

/**
 * Authentication routes
 * These routes are wrapped with AuthLayout in the main routes config
 */
export const authRoutes: RouteObject[] = [
	{
		path: "login",
		element: (
			<IsNotAuthenticated>
				<LoginPage />
			</IsNotAuthenticated>
		),
	},
	{
		path: "funnel/finish-signup",
		element: <FinishSignupPage />,
	},
	{
		path: "register",
		element: (
			<IsNotAuthenticated>
				<RegisterPage />
			</IsNotAuthenticated>
		),
	},
	{
		// Main Firebase action handler - routes based on 'mode' parameter
		path: "action",
		element: (
			<IsNotAuthenticated>
				<ActionHandlerPage />
			</IsNotAuthenticated>
		),
	},
	{
		path: "reset-password",
		element: (
			<IsNotAuthenticated>
				<PasswordResetPage />
			</IsNotAuthenticated>
		),
	},
	{
		path: "verify-email",
		element: (
			<IsNotAuthenticated>
				<EmailVerificationPage />
			</IsNotAuthenticated>
		),
	},
];
